import BusinessIcon from '@mui/icons-material/Business'
import DateRangeIcon from '@mui/icons-material/DateRange'
import BookingsPage from 'Pages/BookingsPage/BookingsPage/BookingsPage'
import CreateSupplierPageNew from 'Pages/Supplier/CreateSupplierPageNew/CreateSupplierPage'
import { StateResourceType } from '../../app/constants/Dashboard/DashboardConstants'
import BookingConfirmationPage from '../../Pages/BookingsPage/BookingConfirmationPage/BookingConfirmationPage'
import CreateBookingPageSwitch from '../../Pages/BookingsPage/CreateBookingPage/CreateBookingPageSwitch'
import BookingStatusPage from '../../Pages/Client/BookingStatusPage/BookingStatusPage'
import ClientManagementPage from '../../Pages/Client/ClientManagementPage/ClientManagementPage'
import ClientSearchPage from '../../Pages/Client/ClientSearchPage/ClientSearchPage'
import CreateClientPageNew from '../../Pages/Client/CreateNew/CreateClientPage'
import SupplierManagementPage from '../../Pages/Supplier/SupplierManagementPage/SupplierManagementPage'
import SupplierSearchPage from '../../Pages/Supplier/SupplierSearchPage/SupplierSearchPage'
import AuthRoutes from '../AuthRoutes/authRoutes'
import ClientResourceRoutes from '../ResourceRoutes/clientRoutes'
import { getHomeRoutes } from './homeRoutes'
import UserProfileRoutes from './userProfileRoutes'

export const jAStateRoutes = [
  {
    stateRouteId: 1,
    stateSource: StateResourceType.CLIENT,
    stateField: 'clientId',
  },
]

export function useJyrneyAdminRoutes(user: any, client: any) {
  return [
    ...AuthRoutes,
    ...UserProfileRoutes,

    {
      stateRouteId: 1,
      path: '/clients/',
      navBarHeading: 'Client Management',
      name: 'Client Management',
      mini: '',
      rtlMini: '',
      rtlName: 'هعذاتسجيل الدخول',
      component: ClientManagementPage,
      layout: '/admin',
    },
    {
      collapse: true,
      name: 'Clients',
      rtlName: 'صفحات',
      icon: BusinessIcon,
      state: 'clientCollapse',
      views: [
        {
          path: '/clients/create',
          navBarHeading: 'Client Administration',
          name: 'Create Client',
          mini: '',
          rtlMini: '',
          rtlName: 'هعذاتسجيل الدخول',
          component: CreateClientPageNew,
          layout: '/admin',
        },

        {
          path: '/clients/search',
          name: 'Find a Client',
          navBarHeading: 'Client Search',
          rtlName: 'إدارة الموردين',
          mini: '',
          rtlMini: '',
          component: ClientSearchPage,
          layout: '/admin',
        },
        ...ClientResourceRoutes,
      ],
    },
    {
      collapse: true,
      name: 'Suppliers',
      rtlName: 'المورد',
      icon: BusinessIcon,
      state: 'supplierCollapse',
      views: [
        {
          path: '/supplier/create/company',
          navBarHeading: 'Supplier Administration',
          name: 'Create Supplier',
          rtlName: 'إنشاء مورد',
          mini: '',
          rtlMini: '',
          component: CreateSupplierPageNew,
          layout: '/admin',
        },
        {
          path: '/supplier/search',
          name: 'Find a Supplier',
          navBarHeading: 'Supplier Search',
          rtlName: 'إدارة الموردين',
          mini: '',
          rtlMini: '',
          component: SupplierSearchPage,
          layout: '/admin',
        },
        {
          path: '/supplier/:id',
          name: 'Supplier Management',
          navBarHeading: 'Supplier Management',
          rtlName: 'إدارة الموردين',
          mini: '',
          rtlMini: '',
          component: SupplierManagementPage,
          layout: '/admin',
          redirect: true,
        },
      ],
    },
    {
      collapse: true,
      name: 'Bookings',
      rtlName: 'صفحات',
      icon: DateRangeIcon,
      state: 'bookingsCollapse',
      views: [
        {
          path: '/bookings/myBookings',
          navBarHeading: 'Bookings',
          name: 'Bookings',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: BookingsPage,
          layout: '/admin',
        },
        {
          path: '/bookings/create?new=true',
          navBarHeading: 'Bookings',
          name: 'Create New Booking',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: CreateBookingPageSwitch,
          layout: '/admin',
        },
        {
          path: '/bookings/journeyStatus',
          navBarHeading: 'Journey Status',
          name: 'Journey Status',
          rtlName: 'هعذاتسجيل الدخول',
          mini: '',
          rtlMini: '',
          component: BookingStatusPage,
          layout: '/admin',
        },
        {
          path: '/bookings/create',
          navBarHeading: 'Bookings',
          name: 'Create Booking',
          component: CreateBookingPageSwitch,
          layout: '/admin',
          redirect: true,
        },
        {
          path: '/bookings/confirmation',
          navBarHeading: 'Booking Confirmation',
          name: 'Booking Confirmation',
          component: BookingConfirmationPage,
          layout: '/admin',
          redirect: true,
        },
      ],
    },
    ...getHomeRoutes(client),
  ]
}
